"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Indicator", {
  enumerable: true,
  get: function () {
    return _TabsIndicator.TabsIndicator;
  }
});
Object.defineProperty(exports, "List", {
  enumerable: true,
  get: function () {
    return _TabsList.TabsList;
  }
});
Object.defineProperty(exports, "Panel", {
  enumerable: true,
  get: function () {
    return _TabsPanel.TabsPanel;
  }
});
Object.defineProperty(exports, "Root", {
  enumerable: true,
  get: function () {
    return _TabsRoot.TabsRoot;
  }
});
Object.defineProperty(exports, "Tab", {
  enumerable: true,
  get: function () {
    return _TabsTab.TabsTab;
  }
});
var _TabsRoot = require("./root/TabsRoot");
var _TabsTab = require("./tab/TabsTab");
var _TabsIndicator = require("./indicator/TabsIndicator");
var _TabsPanel = require("./panel/TabsPanel");
var _TabsList = require("./list/TabsList");